import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
export default {
  name: "biography",
  computed: {
    ...userVuex.mapState(["userInfo", "settingInfo", "isLogin", "userCardInfo"]),
    ...taskVuex.mapState(["taskInfo"]),
    devicePixelRatio() {
      return window.devicePixelRatio;
    }
  },
  data() {
    const tabList = [{
      label: "Overview",
      value: 0
    }, {
      label: "Gallery",
      value: 1
    }];
    return {
      tabList,
      isTab: 0,
      showTab: false,
      lastScrollTop: 0,
      ticking: false,
      // 节流标记

      startX: 0,
      currentX: 0,
      dragging: false,
      translateX: 0,
      // 实时横向位移
      transitionStyle: "none",
      directionLocked: false,
      // true 表示已锁定方向
      isVerticalScroll: false,
      // 是否是纵向滚动意图
      isClick: true // 默认是点击，除非滑动距离超过阈值
    };
  },

  watch: {
    isLogin: {},
    isTab: {
      handler(newTab, oldTab) {
        if (newTab != oldTab) {
          this.translateX = newTab === 0 ? 0 : -window.innerWidth;
          document.documentElement.scrollTop = 0;
        }
      }
    }
  },
  methods: {
    onTab(item) {
      this.isTab = item.value;
    },
    setHeight() {
      this.$nextTick(() => {
        const boxHeight = this.$refs.biographyBoxRef.offsetHeight;
        this.$refs.tabInner.style.height = boxHeight + "px";
      });
    },
    handleScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          const st = window.scrollY || document.documentElement.scrollTop;
          if (st <= 0) {
            this.showTab = false;
          } else if (st >= 10) {
            this.showTab = true;
          }
          console.log("st", st);
          this.ticking = false;
        });
        this.ticking = true;
      }
    },
    onTouchStart(e) {
      const touch = e.touches ? e.touches[0] : e;
      this.startX = touch.clientX;
      this.startY = touch.clientY;
      this.currentX = this.startX;
      this.currentY = this.startY;
      this.dragging = true;
      this.isClick = true; // 默认是点击，除非滑动距离超过阈值
      this.directionLocked = false;
      this.isVerticalScroll = false;
      this.transitionStyle = "none";
    },
    onTouchMove(e) {
      if (!this.dragging) return;
      const touch = e.touches ? e.touches[0] : e;
      const deltaX = touch.clientX - this.startX;
      const deltaY = touch.clientY - this.startY;

      // 如果移动距离超过5px，就不是点击
      if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
        this.isClick = false;
      }
      if (!this.directionLocked) {
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          this.isVerticalScroll = true;
          this.directionLocked = true;
          return;
        } else {
          this.directionLocked = true;
          e.preventDefault();
        }
      }
      if (this.isVerticalScroll) return;
      this.currentX = touch.clientX;
      if (this.isTab === 0 && deltaX > 0 || this.isTab === 1 && deltaX < 0) {
        return;
      }
      const baseOffset = this.isTab === 0 ? 0 : -window.innerWidth;
      this.translateX = baseOffset + deltaX;
    },
    onTouchEnd() {
      if (!this.dragging) return;
      this.dragging = false;
      if (this.isVerticalScroll) {
        this.isVerticalScroll = false;
        document.body.style.userSelect = "";
        return;
      }
      if (this.isClick) {
        // 是点击，不切换 tab
        this.transitionStyle = "transform 0.3s ease";
        this.translateX = this.isTab === 0 ? 0 : -window.innerWidth;
        return;
      }
      const delta = this.currentX - this.startX;
      const threshold = window.innerWidth * 0.3;
      if (Math.abs(delta) > threshold) {
        if (delta < 0 && this.isTab === 0) {
          this.isTab = 1;
        } else if (delta > 0 && this.isTab === 1) {
          this.isTab = 0;
        }
      }
      this.transitionStyle = "transform 0.3s ease";
      this.translateX = this.isTab === 0 ? 0 : -window.innerWidth;
    }
  },
  mounted() {
    this.setWowAnim();
    // 初始化位移
    this.translateX = this.isTab === 0 ? 0 : -window.innerWidth;
    window.addEventListener("scroll", this.handleScroll); // ✅ 修改为 window
  },

  beforeDestroy() {
    window.addEventListener("scroll", this.handleScroll);
  }
};